<template>
  <div class="bg-red-500 text-white text-xs pt-0.5 text-center opacity-75">
    {{ $t('dev_hint') }}
  </div>
</template>
